module.exports = __webpack_public_path__ + "img/N339-2-EN.d2ba7634.png";